// src/pages/Archiver/ActiveSeriesList.js
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Accordion, Spinner, Table } from 'react-bootstrap';
import { formatDate } from '../../utils/helpers';

function ActiveSeriesList() {
  const [seriesList, setSeriesList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    setLoading(true);
    axios.get('/api/exam-series')
      .then(response => {
        setSeriesList(response.data);
        setLoading(false);
      })
      .catch(err => {
        setError('Error fetching exam series.');
        setLoading(false);
      });
  }, []);

  return (
    <div className="container-fluid mt-3">
      <h2>Active Exam Series</h2>
      {loading && <Spinner animation="border" />}
      {error && <p className="text-danger">{error}</p>}

      <Accordion defaultActiveKey="">
        {seriesList
          .filter(series => !series.expired)
          .map((series, index) => (
            <Accordion.Item eventKey={index.toString()} key={series.id}>
              <Accordion.Header>
                {series.name} (Ends: {formatDate(series.endDate)})
              </Accordion.Header>
              <Accordion.Body>
                <p><strong>Start Date:</strong> {formatDate(series.startDate)}</p>
                <p><strong>End Date:</strong> {formatDate(series.endDate)}</p>

                {series.seriesPrograms && series.seriesPrograms.length > 0 ? (
                  <Table striped bordered hover responsive>
                    <thead>
                      <tr>
                        <th>Program</th>
                        <th>Year</th>
                        <th>Semester</th>
                      </tr>
                    </thead>
                    <tbody>
                      {series.seriesPrograms.map((sp, idx) => (
                        <tr key={idx}>
                          <td>{sp.program?.name || 'N/A'}</td>
                          <td>{sp.yearOfStudy?.name || 'N/A'}</td>
                          <td>{sp.semester?.name || 'N/A'}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                ) : (
                  <p className="text-muted">Nothing to show here</p>
                )}
              </Accordion.Body>
            </Accordion.Item>
          ))}
      </Accordion>
    </div>
  );
}

export default ActiveSeriesList;
